import sgr from '../../images/sgr2.webp'
import zip from '../../images/zip.jpg'
import pick from '../../images/pick3.png'

import wild from '../../images/9.jpg'
import adventure from '../../images/adv.jpg'
import vacay from '../../images/vacay.jpg'
import coast from '../../images/coast.webp'
import dayvisit from '../../images/museum.png'

export const ourServices = [
    {
        id:1,
        title: 'Ticketing',
        description:'Want to cross the country, countries or continents? Dga is here to ensure that your experience is not only fast but hussle free',
        cover_image:sgr
    },
    {
        id:2,
        title: 'Adventure tour packages',
        description:"We believe enjoying life doesn't have to be done in large doses. One can enjoy Adventure and life even with only a day to spare. Here at DGA we have a huge array of adventures and excursions that one can undertake in under 12 hours",
        cover_image:zip
    },
    {
        id:3,
        title: 'Excursions',
        description: 'Wherever you may want to go, or you may want an item taken to, DGA got you covered. We provide timely and affordable services 24 hours a day. We are always open to receive your call.',
        cover_image:coast
    },
    {
        id:4,
        title: 'Vacations',
        description: 'Looking to take a breather from the numerous pressures of life & just relax, have  an authentic  Safari experience as you interact with the big five on the African plains or live the beach life on the Kenyan coast.We,can make it happen.',
        cover_image:vacay
    },
    {
        id:5,
        title:"Transfers",
        description: "DGA is your travelling partner.  We are here to ensure that your  trip from the airport to your hotel and vice versa is well covered.",
        cover_image:pick
    }
]


export const packageCategories = [
    {
        id:1,
        title: 'African Safaris',
        tag: 'safari',
        image: wild
    },
    {
        id:5,
        title: 'Vacations',
        tag: 'vacations',
        image: vacay
    },
    {
        id:6,
        title: 'Adventures',
        tag: 'adventures',
        image: adventure
    },
    {
        id:2,
        title: 'Day Tours',
        tag: 'day tours',
        image: dayvisit
    },
    {
        id:3,
        title: 'Coastal',
        tag: 'coast',
        image: coast
    },
    {
        id:4,
        title: 'Wild Tours ',
        tag: 'wild',
        image: wild
    },
    
    
]



